<div class="row" (mouseleave)="hideHelp()">
  <div class="col-md-6 col-lg-8 col-xl-9">
    <mat-card id="Review_Tab">
      <mat-card-header>
        <mat-card-title>Review and confirm</mat-card-title>
      </mat-card-header>
      <mat-divider class="divider-line"></mat-divider>
      <mat-card-content>
        <form class="needs-validation" novalidate>
          <div (mouseover)="showHelp('Review')">
            <div class="row">
              <div class="col-md-12">
                <p class="content-pg-1 top-20 btm-20">
                  All shareholders participating in the buy-back round are listed below.  The final number of shares that each shareholder is eligible to sell is populated by Hissa based on the target number of shares.
                  <br><br>
                  To understand how the buy-back round impacts the cap table, click on <b>‘View Summary’</b>.
                </p>
              </div>
            </div> 
            <div class="row">
              <div class="col-md-6">
                <div class="top-10">
                  <mat-label>Type of Instrument: {{instrumentName}} ({{currencySymbol}} {{getTotalValueTble(pps)}} per share)</mat-label>
                </div>
              </div>
            </div>
            <div class="row">
              <dx-data-grid id="gridContainer" class="grant-table" [hoverStateEnabled]="true" [dataSource]="shareHolders" keyExpr="id" caption="Shareholders table"
               [showBorders]="true" [wordWrapEnabled]="true" [width]="100+'%'"
               [columnAutoWidth]="true" [allowColumnReordering]="false" noDataText="No Shareholders Data available"
              [allowColumnResizing]="true" >
                <dxo-scrolling [useNative]="true" showScrollbar="true"> </dxo-scrolling>
                <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>
                <dxo-filter-row [visible]="false"></dxo-filter-row>
                <dxo-header-filter [visible]="true"></dxo-header-filter>
                <dxo-column-chooser [enabled]="false"></dxo-column-chooser>
                <!-- <dxo-selection mode="multiple" showCheckBoxesMode="always"></dxo-selection> -->
                <dxi-column dataField="name" [allowEditing]="false" [allowFiltering]="true" caption="Shareholder" ></dxi-column>
                <dxi-column dataField="totalShares" [allowSorting]="true" [allowEditing]="false" [allowFiltering]="false" caption="Total Shares"></dxi-column>
                <dxi-column dataField="currentHoldingPercentageLabel" [allowEditing]="false" [allowFiltering]="false" caption="Current Holding Percentage"></dxi-column>
                <dxi-column dataField="proRataEligibility" caption="Eligibility(pro-rata)" [allowFiltering]="false" [allowEditing]="false" style="cursor: pointer;" ></dxi-column>
                <dxi-column dataField="willingness" [allowFiltering]="false"  [allowEditing]="false" caption="Willingness"></dxi-column>
                <dxi-column dataField="finalEligibility" caption="Final Eligibility" [allowFiltering]="false" [allowEditing]="false" style="cursor: pointer;" ></dxi-column>
                <!-- <dxi-column dataField="amountReceived" caption="Amount Received" [allowEditing]="false" style="cursor: pointer;" ></dxi-column> -->
              </dx-data-grid>
            </div>
            <div class="row">
              <div class="col-md-3 top-10">
                <div class="top-10">
                  <mat-label>Target:  {{getTotalValueTble(target)}} shares ({{currencySymbol}} {{getTotalValueTble(totalBuyBackAmount)}})</mat-label>
                </div>
              </div>
              <div class="col-md-5 top-10">
                <div class="top-10 float-right">
                  <mat-label>Actual: </mat-label>
                </div>
              </div>
              <div>
                <div class="top-10">
                  <input type="text" [(ngModel)]="actualTargetSharesText" [ngModelOptions]="{standalone: true}" placeholder="0" class="form-control inputs top-10" disabled />
                </div>
              </div>
            </div>
            <div class="row top-20">
              <div class="col-md-12">
                <button mat-raised-button id="viewSummary" [disableRipple]="disableripple" color="success"
                  class="pull-right " (click)="goToSummary()" ngbTooltip="View Summary">View Summary
                </button>
                <button mat-raised-button id="previous" [disableRipple]="disableripple" color="success"
                  class="pull-right margin-right-20" (click)="goToShareholders()"
                    ngbTooltip="Shareholders Tab">Previous
                </button>
              </div>
            </div>
          </div>
        </form>
      </mat-card-content>
    </mat-card>
  </div>
  <div class="col-md-6 col-lg-4 col-xl-3">
    <div class="helper-container">
        <mat-card id="helperCard" class="card-help help-style" [ngStyle]="{'top.px': helperTopPosition}" [hidden]="helper == ''">
          <mat-card-header class="help-hdr">
            <mat-card-title><label class="help-hdr-txt">{{
               helpSections?.name
              }}</label></mat-card-title>
          </mat-card-header>
          <hr />
          <mat-card-content class="card-help-content">
            <div [innerHTML]="helpSections?.description"></div>
          </mat-card-content>
        </mat-card>
    </div>
  </div>
</div>
